export default __webpack_public_path__ + "static/media/NorbuHomes.4ff596e9.pdf";